import { render } from "./HeroiconsSolidDeviceTablet.vue?vue&type=template&id=3833e286"
const script = {}

import exportComponent from "/var/www/sites/avaliacao/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidDeviceTablet.vue"]])

export default __exports__